import { SwUpdate } from '@angular/service-worker';
import * as i0 from "@angular/core";
import * as i1 from "@angular/service-worker";
var SwLogService = /** @class */ (function () {
    function SwLogService(updates) {
        updates.available.subscribe(function (event) {
            console.log('current version is', event.current);
            console.log('available version is', event.available);
        });
        updates.activated.subscribe(function (event) {
            console.log('old version was', event.previous);
            console.log('new version is', event.current);
        });
    }
    SwLogService.ngInjectableDef = i0.defineInjectable({ factory: function SwLogService_Factory() { return new SwLogService(i0.inject(i1.SwUpdate)); }, token: SwLogService, providedIn: "root" });
    return SwLogService;
}());
export { SwLogService };
